<template>
  <div id="reports-page" class="reporting">
    <div id="reporting-filters"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="reporting-filters-modal-label"
         aria-hidden="true">
      <form class="modal-dialog custom-modal"
            @submit="submitForm($event)">
        <div class="modal-content">
          <div class="modal-header custom-modal-header px-i">
            <div class="custom-modal-header-start">
              <h4 class="modal-title custom-modal-header-start-title">
                {{ $t('common.filterInvoices') }}
              </h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <fieldset class="modal-body custom-modal-body px-i"
                    :disabled="isFormDisabled">
            <div class="form-card-group">
              <div class="form-card-group-item form-card-group-item-vertical col-24 col-md-12">
                <div class="form-group custom-form-group">
                  <label class="custom-form-group-label" for="invoice-report-customer-name">
                    {{ $t('common.customer') }}
                  </label>
                  <div class="custom-input-group">
                    <div class="input-group custom-input-group-input">
                      <multiselect
                        v-if="customers.length"
                        id="invoice-report-customer-name"
                        v-model="selectedCustomer"
                        class="model-list-select mb-0"
                        track-by="id"
                        label="display_name"
                        :show-labels="false"
                        :show-pointer="false"
                        :options="customerOptions"
                        :internal-search="false"
                        @search-change="customerSearch"
                        @select="resetCustomers">
                        <template slot="singleLabel" slot-scope="props">
                          <span>
                            {{ props.option.display_name }}
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="model-list-select-option">
                            <div class="model-list-select-option-start">
                              <i class="demo-icon" :class="customerIcon(props.option.account_type)" />
                              <div class="model-list-select-option-start-text">
                                <h3>
                                  {{ customerOptionText(props.option) }}
                                </h3>
                                <div v-if="props.option.email" class="mt-2 d-block d-md-none">
                                  {{ props.option.email }}
                                </div>
                              </div>
                            </div>
                            <div class="model-list-select-option-end d-none d-md-block">
                              {{ props.option.email }}
                            </div>
                          </div>
                        </template>
                        <template slot="caret">
                          <div class="model-list-select-icon">
                            <i class="demo-icon icon-search" />
                          </div>
                        </template>
                        <template slot="noResult">
                          No results
                        </template>
                      </multiselect>
                      <input
                        v-else
                        id="invoice-report-customer-name"
                        v-model="companyId"
                        type="text"
                        class="form-control custom-input">
                    </div>
                  </div>
                </div>
                <div class="form-group custom-form-group">
                  <label class="custom-form-group-label" for="invoice-report-invoice-number">{{ $t('invoice.number') }}</label>
                  <div class="custom-input-group">
                    <div class="input-group custom-input-group-input">
                      <multiselect
                        id="invoice-report-invoice-number"
                        v-model="selectedInvoiceNumber"
                        class="model-list-select mb-0"
                        track-by="id"
                        label="display_name"
                        :show-labels="false"
                        :show-pointer="false"
                        :options="itemOptions"
                        :internal-search="false"
                        @search-change="invoiceNumberSearch"
                        @select="resetItems">
                        <template slot="singleLabel" slot-scope="props">
                          <span>
                            {{ props.option.invoice_merchant_number }}
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="model-list-select-option">
                            <div class="model-list-select-option-start">
                              <i class="demo-icon icon-receipt" />
                              <div class="model-list-select-option-start-text">
                                <h3>
                                  {{ invoiceNumberOptionText(props.option) }}
                                </h3>
                                <div class="status-indicator text-capitalize mt-2 d-block d-md-none" :class="statusCellClass(props.option.invoice_status)">
                                  {{ props.option.invoice_status }}
                                </div>
                              </div>
                            </div>
                            <div class="model-list-select-option-end d-none d-md-block">
                              <div class="status-indicator text-capitalize" :class="statusCellClass(props.option.invoice_status)">
                                {{ props.option.invoice_status }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <template slot="caret">
                          <div class="model-list-select-icon">
                            <i class="demo-icon icon-search" />
                          </div>
                        </template>
                        <template slot="noResult">
                          No results
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="form-group custom-form-group">
                  <label
                    class="custom-form-group-label"
                    for="invoice-report-payment-method">{{ $t('common.paymentMethod') }}</label>

                  <select
                    id="invoice-report-payment-method"
                    v-model="invoiceReportFormData.paymentMethodId"
                    class="custom-select custom-input">
                    <option value>
                      {{ $t('common.all') }}
                    </option>
                    <option
                      v-for="paymentMethod in orderedPaymentMethods"
                      :key="paymentMethod.id"
                      :value="paymentMethod.id">
                      {{ paymentMethod.title ? paymentMethod.title.en : paymentMethod.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group custom-form-group">
                  <label
                    class="custom-form-group-label"
                    for="invoice-report-voucher-type"> Voucher Type</label>

                  <select
                    id="invoice-report-voucher-type"
                    v-model="invoiceReportFormData.invoice_voucher_type"
                    class="custom-select custom-input">
                    <option value>
                      {{ $t('common.all') }}
                    </option>
                    <option
                      v-for="voucherType in VoucherTypes"
                      :key="voucherType.key"
                      :value="voucherType.value">
                      {{ voucherType.value }}
                    </option>
                  </select>
                </div>
                <div class="form-group custom-form-group">
                  <label class="custom-form-group-label" for="invoice-report-currency">{{ $t('common.currency') }}</label>
                  <select
                    id="invoice-report-currency"
                    v-model="invoiceReportFormData.currencyId"
                    class="custom-select custom-input">
                    <option value>
                      {{ $t('common.all') }}
                    </option>
                    <option
                      v-for="currency in invoiceReportFormData.currencies"
                      :key="currency.id"
                      :value="currency.id">
                      {{ currency.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-card-group-item form-card-group-item-vertical col-24 col-md-12">
                <DateTimePicker
                  v-model="invoiceReportFormData.fromDate"
                  name="from_date"
                  :label-text="$t('invoice_report.invoice_start')" />
                <DateTimePicker
                  v-model="invoiceReportFormData.toDate"
                  name="to_date"
                  :label-text="$t('invoice_report.invoice_end')"
                  :min-date="invoiceReportFormData.fromDate" />
                <DateTimePicker
                  v-model="invoiceReportFormData.paymentFrom"
                  name="from_payment_date"
                  :label-text="$t('invoice_report.payment_start')" />
                <DateTimePicker
                  v-model="invoiceReportFormData.paymentTo"
                  name="to_payment_date"
                  :label-text="$t('invoice_report.payment_end')"
                  :min-date="invoiceReportFormData.paymentFrom" />
              </div>
            </div>
          </fieldset>
          <div class="modal-footer custom-modal-footer px-i">
            <button type="submit"
                    class="btn btn-primary ihjoz-button ihjoz-button-big-size">
              {{ $t('common.filter') }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <InvoiceReportTable :columns="columns"
                        item-name="invoice"
                        :items="items"
                        :enable-links="enableLinks"
                        :links-domain="linksDomain"
                        :new-button-title="newButtonTitle"
                        :new-button-url="newButtonUrl"
                        :show-total-row="showTotalRow"
                        :total-currency="totalCurrency"
                        :export-filename="exportFilename"
                        :enable-dropdown="enableDropdown"
                        :dropdown-options="dropdownOptions"
                        @dropdownChanged="dropdownChanged($event)" />
  </div>
</template>

<script>
/* eslint-disable no-undef */

import InvoiceReportTable from "./InvoiceReportTable.vue";
import DateTimePicker from "@shared/components/UI/DateTimePicker.vue";
import Multiselect from "vue-multiselect";
import createSearchRegexp from "@shared/createSearchRegexp";

export default {
  name: "InvoiceReport",

  components: {
    InvoiceReportTable,
    DateTimePicker,
    Multiselect
  },

  props: {
    exportFilename: { type: String, default: "" },
    columns: { type: Array, required: true },
    formStore: { type: Object, required: true },
    newButtonTitle: { type: String, default: "" },
    newButtonUrl: { type: String, default: "" },
    customFormattedColumns: { type: Array },
    enableLinks: { type: Boolean, default: true },
    enableDropdown: { type: Boolean, default: false },
    dropdownOptions: { type: Array },
    customers: { type: Array, default: () => [] },
    linksDomain: { type: String, default: "" }
  },

  data () {
    return {
      isFormDisabled: false,
      selectedInvoiceNumber: null,
      selectedCustomer: null,
      invoiceReportFormData: this.formStore.data,
      items: [],
      itemOptions: [],
      companyId: "",
      customerOptions: this.customers,
      VoucherTypes: Dashboard.templateTypes
    };
  },

  computed: {
    orderedPaymentMethods () {
      return _.orderBy(
        this.invoiceReportFormData.paymentMethods,
        "visual_order_number"
      );
    },

    totalCurrency () {
      if (this.items[0]) {
        if (this.items[0].invoice_currency_iso_code === "LBP") {
          return { code: this.items[0].invoice_currency_iso_code, precision: 0 };
        } else {
          return { code: this.items[0].invoice_currency_iso_code, precision: 2 };
        }
      } else {
        return {};
      }
    },

    showTotalRow () {
      if (this.items[0]) {
        let firstValue = this.items[0].invoice_currency_iso_code;

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].invoice_currency_iso_code !== firstValue) {
            return false;
          }
        }

        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    "selectedCustomer": function (newVal, _) {
      if (newVal) {
        this.invoiceReportFormData.customerName = newVal.display_name;
      }
    },

    "selectedInvoiceNumber": function (newVal, _) {
      if (newVal) {
        this.invoiceReportFormData.invoiceMerchantNumber = newVal.invoice_merchant_number;
      }
    }
  },

  async created () {
    this.formStore.loadPaymentMethodsAndCurrencies();

    if (this.$route.params.companyId) {
      this.companyId = this.$route.params.companyId;
    } else {
      this.companyId = "";
    }

    this.updateForm();
  },

  methods: {
    submitForm (e) {
      this.isFormDisabled = true;

      this.updateForm();
      $("#reporting-filters").modal("hide");
      e.preventDefault();
    },

    formatDate (dateString) {
      if (!dateString) {
        return "";
      }
      return new Date(dateString).toJSON().slice(0, 10);
    },

    async updateForm () {
      try {
        this.items = await this.formStore.loadReports(this.companyId);
        this.itemOptions = this.items;
      } finally {
        this.isFormDisabled = false;
      }
    },

    dropdownChanged (e) {
      this.$emit("dropdownChanged", e);
      this.formStore.changeReportStatus(e);
      this.isFormDisabled = true;
      this.updateForm();
    },

    customerSearch (query) {
      let searchRegexp = createSearchRegexp(query, false, true, true);

      this.customerOptions = this.customers.filter((customer) => {
        return searchRegexp.test(
          customer.display_name + customer.company_name + customer.email + customer.mobile_number);
      });
    },

    invoiceNumberSearch (query) {
      let searchRegexp = createSearchRegexp(query, false, true, true);

      this.itemOptions = this.items.filter((invoice) => {
        return searchRegexp.test(invoice.invoice_customer_name + invoice.invoice_merchant_number);
      });
    },

    customerIcon (type) {
      if (type === "Individual") {
        return "icon-user";
      } else {
        return "icon-building";
      }
    },

    customerOptionText (customer) {
      if (customer.account_type === "Individual") {
        return customer.display_name;
      } else {
        return `${customer.display_name} - ${customer.first_name} ${customer.last_name}`;
      }
    },

    invoiceNumberOptionText (invoice) {
      return `${invoice.invoice_merchant_number} - ${invoice.invoice_customer_name} - ${invoice.invoice_currency_sign}${invoice.invoice_total}`;
    },

    resetCustomers (selectedOption, id) {
      this.customerOptions = this.customers;
    },

    resetItems (selectedOption, id) {
      this.itemOptions = this.items;
    },

    statusCellClass (status) {
      let badges = {
        paid: "success",
        outstanding: "secondary",
        refunded: "info",
        refundable: "info",
        cancelled: "warning",
        expired: "danger",
        void: "warning",
        overdue: "danger",
        draft: "danger"
      };

      return `status-indicator badge-${badges[status]}`;
    }
  }
};
</script>
